import { useEffect } from "react";
import useNotificationStore from "../stores/notificationStore";
import './notification.css';

export default function Notification() {
  const { notification, clearNotification } = useNotificationStore();

  useEffect(() => {
    if (!notification) return;

    const timer = setTimeout(() => {
      clearNotification();
    }, 6000); // 秒後に自動消去

    return () => clearTimeout(timer);
  }, [notification, clearNotification]);

  if (!notification) return null;

  return (
    <div className={`notification notification--${notification.type}`}>
      <div className="notificationContent">
        <span className="notificationIcon">
          {notification.type === 'success' && '✓'}
          {notification.type === 'error' && '✕'}
          {notification.type === 'info' && 'ℹ'}
        </span>
        <span className="notificationText">
          {notification.message}
        </span>
      </div>

      {/* <button
        className="notificationClose"
        onClick={clearNotification}
        aria-label="閉じる"
      >
        ✕
      </button> */}
    </div>
  );
}